/**
 * Created by rastwe on 1/13/2017.
 */
 import * as React from "react";
 import styled, {css} from 'styled-components';
 import * as PropTypes from 'prop-types';
 import {ifProp, switchProp} from 'styled-tools';
 export interface EYLogoProps {
    logoType: string;    
  }
 
 const StyledEYLogo = styled.figure`
     display: inline-block;
     line-height: normal;
     margin: 0;
     overflow: hidden;
     vertical-align: top;
    width: var(--px-16);
    height: var(--px-16);
     svg {
         height: 100%;
         width: 100%;
 
         .path1,
         .path2 {
             fill: var(--neutrals-900);
         }
     }
 `;
 
 const StyledPath = styled.path`
     &&& {
         ${switchProp('logotype', {
             charcoal: css`
                 fill: var(--neutrals-900);
             `
         })}
     }
 `;
 
 class EYLogo extends React.Component<EYLogoProps> {
     constructor(props: EYLogoProps) {
         super(props);
         this.state = {};
     }
 
     /*
      * Use of SVG in JSX requires some transforming of the invalid xml syntax
      * xmlnsXlink --> xmlnsXlink
      * xlink:href --> xlinkHref
      */
 
     static propTypes = {
         /** String defining the style of logo */
         logoType: PropTypes.string
     };
 
     static defaultProps = {
         /** String defining the style of logo */
         logoType: ''
     };
 
     render() {
         const {logoType} = this.props;
 
         return (
             <StyledEYLogo>
                 <svg
                     id="icon-ey-logo"
                     viewBox="8.9 2.9 20 20"
                     width="100%"
                     height="100%"
                 >
                     <title />
                     <StyledPath
                         className="path1 fill-color2"
                         //logotype={logoType}
                         d="M12.399 18.694h3.449v-2.003h-3.449v-1.574h3.815l-1.266-2.194h-5.41v9.538h7.63v-2.194h-4.77z"
                     />
                     <StyledPath
                         className="path2 fill-color2"
                         //logotype={logoType}
                         d="M22.247 12.923l-1.62 3.113-1.616-3.113h-3.163l3.333 5.771v3.768h2.852v-3.768l3.337-5.771z"
                     />
                     <StyledPath
                         fill="#ffd400"
                         className="path3 fill-color1"
                         d="M28.23 3.179l-18.857 6.882 18.857-3.331z"
                     />
                 </svg>
             </StyledEYLogo>
         );
     }
 }
 
 export default EYLogo;
 